import React from 'react'
import {PageTitle} from '../../Components/Landmarks';
import type { ContextProps } from '../../types';
import {InputForm} from '../../Components/Inputs';
import {CheckInFormView} from '../../Components/CheckIn/CheckInFormView';
import {LayoutMedium} from "@components/Layout";

export const CheckInContainer = ({
                                     handleApiCall,
                                     setWarnings,
                                     systemTypeText,
                                 }: ContextProps) => {


    return <>
        <LayoutMedium>
            <PageTitle h1={`Check In - ${systemTypeText}`}/>
            <InputForm name={"CheckIn"}>
                <CheckInFormView handleApiCall={handleApiCall} setWarnings={setWarnings}/>
            </InputForm>
        </LayoutMedium>
    </>
}

